(ns ui.subscription.change-plan
  (:require [storrito.ui.spinner :as spinner]
            [ui.app-frame :as app-frame]
            [parts.replicant.query :as query]
            [ui.subscription.buy :as buy]
            [ui.subscription.core :as core]
            [ui.elements]))

(def subscription-update-query
  {:query/kind :query/subscription-update})

(defn try-parse-int
  [s]
  (let [n (js/parseInt s 10)]
    (if (js/isNaN n)
      nil
      n)))

(defn panel
  [state]
  (let [{:keys [organization/paddle-subscription]} (query/get-result state
                                                                     subscription-update-query)
        current-plan (first (:items paddle-subscription))]
    (when current-plan
      [:div {:class ["max-w-3xl"]}
       [:h1.mb-2
        {:class ui.elements/h2}
        "Change Your Subscription"]
       [:p.mb-6
        {:class ui.elements/p}
        "Easily update the billing interval, or adjust the subscription amount."]

       ;; Two panels: Current Plan (left), New Plan (right)
       (buy/change-plan-panel state)])))

(defn render
  [state]
  (app-frame/app-frame
    state
    (if (query/loading? state
                        subscription-update-query)
      (spinner/vire-spinner-xs)
      (panel state))))

(def page
  {:page-id :pages/subscription-change-plan
   :route [["ui" "subscription" "change-plan"]]
   :on-load (fn [_location]
              (conj
                core/query-actions
                [:data/query subscription-update-query]))
   :render #'render})
